import React from "react";

export const Trash = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 18 18"
    >
      <path
        d="M15.75 3.75h-3V3c0-1.275-.975-2.25-2.25-2.25h-3C6.225.75 5.25 1.725 5.25 3v.75h-3c-.45 0-.75.3-.75.75s.3.75.75.75H3V15c0 1.275.975 2.25 2.25 2.25h7.5c1.275 0 2.25-.975 2.25-2.25V5.25h.75c.45 0 .75-.3.75-.75s-.3-.75-.75-.75zm-9-.75c0-.45.3-.75.75-.75h3c.45 0 .75.3.75.75v.75h-4.5V3zm6 12.75c.45 0 .75-.3.75-.75V5.25h-9V15c0 .45.3.75.75.75h7.5z"
        clipRule="evenodd"
      />
    </svg>
  );
};
